import { userService } from './../../../Services/userService';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { restURL } from '../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { renewPolicyModel } from '../../../Models/policyModel';
import { LanguageService } from '../../../Services/languageService';
import { motorProposalService } from '../../../Services/motorProposalService';
import { RenewBindMdl } from '../../../Models/RenewBindMdl';
import { TPLProposal } from '../../../Models/TPLProposal';
import { renewalProposalService } from '../../../Services/renewalProposalService';
import { mdlPremiumAndVehicleInfoCompRenewalRes } from '../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';


@Component({
    selector: 'CompRenewalProposal',
    templateUrl: './CompRenewalProposal.html',
    styleUrls: ['./CompRenewalProposal.css']
})
export class CompRenewalProposal {
    public isShowLoading: boolean = false;
    public Lng: string;
    public LngSubscription: Subscription;
    public renewPolicyReq: renewPolicyModel = new renewPolicyModel();
    public bindObj: RenewBindMdl = new RenewBindMdl();
    public prObj: TPLProposal = new TPLProposal();
    public objPremiumAndVehicleInfoRes: mdlPremiumAndVehicleInfoCompRenewalRes = new mdlPremiumAndVehicleInfoCompRenewalRes();
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

    constructor(private EncriptService: motorProposalService,private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private userinfo: userService, private lngService: LanguageService) {
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }
        //this.objPremiumAndVehicleInfoRes = JSON.parse(sessionStorage.getItem("objPremiumAndVehicleInfoRes"));
        this.objPremiumAndVehicleInfoRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objPremiumAndVehicleInfoRes")));
       

    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalProposal/CompRenewalProposal.ts